// src/utils/isSameDate.js
import { isSameMonth } from './isSameMonth';

export function isSameDate(date, comparison) {
  if (!date || !comparison) return false;

  // ensure both are Date objects
  const d1 = date instanceof Date ? date : new Date(date);
  const d2 = comparison instanceof Date ? comparison : new Date(comparison);

  return isSameMonth(d1, d2) && d1.getDate() === d2.getDate();
}
